module.exports = __webpack_public_path__ + "img/Indie-games-engine-distribution.416a9c92.webp";